import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';

import './TextBottom.scss';

const propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
    animate: PropTypes.oneOf([null, 'in', 'out']),
    component: PropTypes.string,
    background: PropTypes.oneOf([null, 'dark', 'light']),
};

const defaultProps = {
    children: null,
    animate: null,
    component: 'p',
    background: null,
};

const TextBottom = ({ children, color, animate, component, background }) => {
    const colorClass = `TextBottom__${color}`;
    return (
        <div className={['TextBottom', colorClass].join(' ')}>
            <Text background={background} className={color} animate={animate} component={component}>
                {children}
            </Text>
        </div>
    );
};

TextBottom.propTypes = propTypes;
TextBottom.defaultProps = defaultProps;

export default TextBottom;
